import { constantRoutes } from '@/router';
import { Component, Vue } from 'vue-property-decorator';
import RouteItem from './route.item/route.item.vue';

/**
 * 布局底部组件
 */
@Component({ name: 'LayoutFooter', components: { RouteItem } })
export default class extends Vue {
    /**
     * 路由的路径
     */
    public get routes() {
        return constantRoutes[0].children;
    }
}
